import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import { injectIntl, defineMessages } from 'react-intl';

import { checkSystemRequirements } from 'OPENTOK/actions/browser';
import { initConnectSession } from 'OPENTOK/actions/session';
import { initPublisher, publishPublisherToSession } from 'OPENTOK/actions/publisher';
import { checkScreenSharingCapability } from 'OPENTOK/actions/screen_sharing';
import { subscribeStream } from 'OPENTOK/actions/subscriber';
import { SESSION_STATUS_INIT, SESSION_STATUS_CONNECTED } from 'OPENTOK/models/session';
import { SUBSCRIBER_STATUS_INIT, SUBSCRIBER_STATUS_CONNECTED } from 'OPENTOK/models/subscriber';
import recordWebrtcHistory from 'BROWSER_TEST/record_webrtc_history';
import { WEBRTC_ACTION_TYPES } from 'COMMONS/api/webrtc_history';

import MinediaNetworkCalculator from '../libs/otnetwork_calculator';

const mapStateToProps = (state) => ({
  browser: state.getIn(['ot', 'browser']),
  session: state.getIn(['ot', 'sessions']).first(),
  publisher: state.getIn(['ot', 'publishers']).first(),
  subscriber: state.getIn(['ot', 'subscribers']).first(),
  streams: state.getIn(['ot', 'streams']),
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      checkSystemRequirements,
      checkScreenSharingCapability,
      initConnectSession,
      initPublisher,
      publishPublisherToSession,
      subscribeStream,
    },
    dispatch,
  ),
});

const intlMessages = defineMessages({
  alert: {
    id: 'browser_test.alert',
    defaultMessage: 'カメラ・マイクの利用を許可してください。',
  },
  remaining_second: {
    id: 'browser_test.remaining_second',
    defaultMessage: '残り{seconds}秒...',
  },
  speed_check_is_finished: {
    id: 'browser_test.speed_check_is_finished',
    defaultMessage: '測定終了',
  },
  fast: { id: 'browser_test.fast', defaultMessage: '速い' },
  average: { id: 'browser_test.average', defaultMessage: '普通' },
  slow: { id: 'browser_test.slow', defaultMessage: 'やや遅い' },
});

@injectIntl
@connect(mapStateToProps, mapDispatchToProps)
export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allChecked: false,
      finishNetworkTest: false,
    };

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }
  componentDidMount() {
    this.props.checkSystemRequirements();
    this.props
      .checkScreenSharingCapability()
      .then((response) => {
        recordWebrtcHistory(
          WEBRTC_ACTION_TYPES.OT_SUUPPORT_CHECK_SCREEN_SHARING_CAPABILITY,
          JSON.stringify(response),
        );
      })
      .catch((response) => {
        recordWebrtcHistory(
          WEBRTC_ACTION_TYPES.OT_NOT_SUUPPORT_CHECK_SCREEN_SHARING_CAPABILITY,
          JSON.stringify(response),
        );
      });
    $('#checking_scene #check_list').on('ifChanged', 'input', this.handleCheckboxChange);
    this.handleCheckboxChange();
    $('#js_connectivity_submit_button').on('click', () => {
      if (!$('#js_connectivity_submit_button').prop('disabled')) {
        recordWebrtcHistory(WEBRTC_ACTION_TYPES.CLICK_SUBMIT_BUTTON);
      }
    });
  }

  submit(results) {
    const { intl } = this.props;

    if ($('#answer_connectivity_bits_data').length !== 0) {
      $('#answer_connectivity_bits_data')[0].value = JSON.stringify(results);
    } else {
      $('#browser_test_history_bits_data')[0].value = JSON.stringify(results);
    }

    const bists = results.video[results.video.length - 1].bitrate;
    let text;
    if (bists > 300) {
      text = $('#js_connectivity_result').text(intl.formatMessage(intlMessages.fast));
    } else if (bists > 100) {
      text = $('#js_connectivity_result').text(intl.formatMessage(intlMessages.average));
    } else {
      text = $('#js_connectivity_result').text(intl.formatMessage(intlMessages.slow));
    }
    text.show();
  }

  updateButtonDisabled() {
    $('#checking_scene #js_connectivity_submit_button').prop(
      'disabled',
      !(this.state.allChecked && this.state.finishNetworkTest),
    );
  }

  handleCheckboxChange() {
    let allChecked = true;
    $('#checking_scene #check_list input').each(function() {
      allChecked = allChecked && $(this).is(':checked');
    });

    this.setState({
      allChecked,
    },
    () => {
      this.updateButtonDisabled();
    });

    if (allChecked) {
      $('.js_show_after_checked').fadeTo('fast', 1.0);
      $('#js_connectivity_field').show();
    } else {
      $('.js_show_after_checked').fadeTo('fast', 0.5);
      $('#js_connectivity_field').hide();
    }
  }

  hideAll() {
    $('.connectivity_scene').hide();
  }

  showScene(name) {
    this.hideAll();
    $(`#${name}`).show();
  }

  handleDeviceAccessError() {
    this.showScene('device_access_error_scene');
  }

  componentDidUpdate(prevProps) {
    const { intl } = this.props;

    if (
      this.props.browser.get('isWebRTCSupportBrowser') !==
      prevProps.browser.get('isWebRTCSupportBrowser')
    ) {
      const { apiKey, sessionId, token } = $('#opentok_config').data();
      this.props
        .initConnectSession(apiKey, sessionId, token)
        .then(() => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_SESSION_CONNECTED);
        })
        .catch((err) => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_ERR_SESSION_CONNECTED, err);
        });
    }
    if (
      prevProps.session &&
      prevProps.session.get('status') === SESSION_STATUS_INIT &&
      this.props.session &&
      this.props.session.get('status') === SESSION_STATUS_CONNECTED
    ) {
      const session = this.props.session;
      const properties = {
        publishAudio: true,
        publishVideo: true,
        width: 440,
        height: 340,
        insertDefaultUI: false,
        facingMode: "user",
        style: {
          showArchiveStatus: false,
          buttonDisplayMode: 'off',
          nameDisplayMode: 'on',
        },
      };

      const opsHandlers = () => ({
        accessDenied: () => {
          this.handleDeviceAccessError();
          alert(intl.formatMessage(intlMessages.alert));
        },
      });

      this.props
        .initPublisher('camera', properties, null, opsHandlers)
        .then((publisherId) => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_INIT_PUBLISH);
          return publisherId;
        })
        .catch(({ err }) => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_ERR_INIT_PUBLISH, err);
        })
        .then((publisherId) => this.props.publishPublisherToSession(publisherId, session.get('id')))
        .then(() => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_PUBLISH);
        })
        .catch(({ err }) => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_ERR_PUBLISH, err);
        });
    }

    if (!prevProps.streams.first() && this.props.streams.first()) {
      const stream = this.props.streams.first();
      // sessionObject.subscribe();
      this.props
        .subscribeStream(
          this.props.session.get('id'),
          stream.get('object'),
          {
            insertDefaultUI: true,
            testNetwork: true,
            width: '100%',
            height: 340,
            style: {
              showArchiveStatus: false,
              buttonDisplayMode: 'off',
              nameDisplayMode: 'on',
            },
          },
          'js_test_video_area',
        )
        .then(() => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_SUBSCRIBE);
        })
        .catch((err) => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_ERR_SUBSCRIBE, err);
        });
    }

    if (
      prevProps.subscriber &&
      prevProps.subscriber.get('status') === SUBSCRIBER_STATUS_INIT &&
      this.props.subscriber &&
      this.props.subscriber.get('status') === SUBSCRIBER_STATUS_CONNECTED
    ) {
      const subscriberObject = this.props.subscriber.get('object');
      const onSubscribe = MinediaNetworkCalculator(
        (progress, seconds) => {
          $('#js_connectivity_progress').progress('set percent', progress);
          $('#js_connectivity_progress .label').text(
            intl.formatMessage(intlMessages.remaining_second, { seconds }),
          );
        },
        (results) => {
          $('#js_connectivity_progress').progress('set percent', 100);
          $('#js_connectivity_progress .label').text(
            intl.formatMessage(intlMessages.speed_check_is_finished),
          );

          this.setState({
            finishNetworkTest: true,
          },
          () => {
            this.updateButtonDisabled();
          });
          console.log(results);

          this.submit(results);
        },
      );
      onSubscribe(subscriberObject);
    }
  }

  render() {
    const { publisher } = this.props;
    if (publisher) {
      const audioDisplayTag = document.getElementById('js_mic_bar_area');
      const audioLevel = publisher.get('audioLevel');
      const tagCount = audioDisplayTag.parentNode.offsetWidth / 10;
      audioDisplayTag.style.width = `${Math.ceil(tagCount * audioLevel) * 10}px`;
    }

    const browser = this.props.browser;
    const support = browser.get('isWebRTCSupportBrowser');
    const extension = browser.get('isScreenSharingExtensionInstalled');

    return <div />;
  }
}
